/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import * as types from './actionTypes';

const initialState = {
  showModal: false,
  upgradingPlan: false,
  upgradingPlanName: null,
  upgradingPlanError: null,
  showUpgrade: true,
  featureName: 'any',
  planName: null,
  plusSelfService: false,
  noPlusTrial: false,
  gettingAccount: false,
  accountType: null,
  apiUsage: { count: 0 },
  upgradeTo: null
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_MODAL:
      return {
        ...state,
        showModal: true,
        featureName: action.featureName,
        planName: action.planName,
        noPlusTrial: action.noTrial,
        upgradeTo: action.upgradeTo
      };
    case types.CLOSE_MODAL:
      return {
        ...state,
        showModal: false
      };
    case types.UPGRADE_PLAN_START:
      return {
        ...state,
        upgradingPlan: true,
        upgradingPlanError: null
      };
    case types.UPGRADE_PLAN_SUCCESS:
      return {
        ...state,
        upgradingPlan: false,
        upgradingPlanName: action.upgradingPlanName
      };
    case types.UPGRADE_PLAN_ERROR:
      return {
        ...state,
        upgradingPlan: false,
        upgradingPlanError: action.error
      };
    case types.GET_ACCOUNT_TYPE:
      return {
        ...state,
        gettingAccount: true,
        accountType: null
      };
    case types.ACCOUNT_TYPE_SUCCESS:
      return {
        ...state,
        gettingAccount: false,
        accountType: action.accountType
      };
    case types.ACCOUNT_TYPE_ERROR:
      return {
        ...state,
        gettingAccount: false,
        accountType: null
      };
    case types.API_USAGE_SUCCESS:
      return {
        ...state,
        apiUsage: { count: action.count }
      };
    default:
      return state;
  }
};

export default reducer;
